import React from 'react';
import styled from 'styled-components';
import ProductAdderBody from './ProductAdderBody';
import ProductAdderHeader from './ProductAdderHeader';
import { device } from '@src/common/breakpoints';
import { useAppSelector, useWidgetParam } from '@src/core/hooks';
import { productSelector } from '@src/features/product';

const ProductAdderRoot = () => {
  const productId = useWidgetParam('product-id')!;
  const product = useAppSelector(productSelector(productId));

  return (
    <ProductAdderArea data-cy='productAdderModal'>
      <ProductAdderHeader title={product?.name ?? ''} />
      <ProductAdderBody />
    </ProductAdderArea>
  );
};

const ProductAdderArea = styled.div`
  background-color: white;
  width: 100%;
  pointer-events: all;
  overflow: hidden;

  ${device.smallTablet} {
    border-radius: 8px;
  }
`;

export default ProductAdderRoot;
